/** Adds the Judge.me "Verified" pill to product-review authors. */
(() => {
  const WIDGET_SELECTOR = '#judgeme_product_reviews';
  const REVIEW_SELECTOR = '.jm-review-item';
  const NAME_SELECTOR = '.jm-reviewer-info__name';
  const BADGE_CLASS = 'ecoroad-review-verified-badge';
  const STYLE_ID = 'ecoroad-review-verified-badge-styles';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .${BADGE_CLASS} {
        box-sizing: border-box;
        display: inline-flex;
        align-items: center;
        min-height: 24px;
        padding: 2px 10px;
        border: 1px solid currentColor;
        border-radius: 999px;
        color: #111;
        font-family: inherit;
        font-size: 12px;
        font-weight: 500;
        line-height: 1.15;
        white-space: nowrap;
      }
    `;
    document.head.appendChild(style);
  }

  function addBadge(review) {
    if (!(review instanceof Element)) return;
    const name = review.querySelector(NAME_SELECTOR);
    if (!name) return;

    // Judge.me can move the name/badge row while Vue re-renders a card, so
    // inspect the complete review item instead of relying on one parent node.
    const nativeBadges = review.querySelectorAll('.jm-verified-buyer-badge');
    const customBadges = review.querySelectorAll('.' + BADGE_CLASS);
    if (nativeBadges.length) {
      customBadges.forEach((badge) => badge.remove());
      return;
    }
    // Clean up duplicates left by a previous render, keeping the first one.
    customBadges.forEach((badge, index) => {
      if (index > 0) badge.remove();
    });
    if (customBadges.length) return;

    const badge = document.createElement('span');
    badge.className = BADGE_CLASS;
    badge.textContent = 'Verified';
    badge.setAttribute('aria-label', 'Verified buyer');
    name.insertAdjacentElement('afterend', badge);
  }

  function decorateReviews(root) {
    if (!(root instanceof Element)) return;
    const parentReview = root.closest(REVIEW_SELECTOR);
    if (parentReview) addBadge(parentReview);
    if (root.matches(REVIEW_SELECTOR)) addBadge(root);
    root.querySelectorAll(REVIEW_SELECTOR).forEach(addBadge);
  }

  function initialise() {
    const widget = document.querySelector(WIDGET_SELECTOR);
    if (!widget || widget.dataset.customeVerifiedReady === 'true') return;

    widget.dataset.customeVerifiedReady = 'true';
    injectStyles();
    decorateReviews(widget);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) decorateReviews(node);
        });
      });
    });
    observer.observe(widget, { childList: true, subtree: true });

    // The image lightbox is mounted outside #judgeme_product_reviews. Watch
    // the document as well so review cards rendered inside that popup receive
    // the same badge and duplicate cleanup.
    const popupObserver = new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) decorateReviews(node);
        });
      });
    });
    popupObserver.observe(document.body, { childList: true, subtree: true });
  }

  function waitForWidget() {
    if (document.querySelector(WIDGET_SELECTOR)) return initialise();

    const pageObserver = new MutationObserver(() => {
      if (!document.querySelector(WIDGET_SELECTOR)) return;
      pageObserver.disconnect();
      initialise();
    });
    pageObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForWidget, { once: true });
  } else {
    waitForWidget();
  }
})();
